import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const Container = styled.div`
	padding: 1rem 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Input = styled.input`
	margin-right: 0.5rem;
`;

const TextInput = styled.input`
	margin-right: 0.5rem;
  border-radius: 4px;
	border: 1px solid #757575;
  padding: 4px;
`;

const Description = styled.span`
	color: #787878;
	font-size: 14px;
	margin: 0 0 8px;
	word-wrap: break-word;
`;

const Tag = props => {
	const { t, lng, tagAlternateText } = props;
	const handleAlternativeTagText = (text) => {
		props.changesHandler({
			tagAlternateText: {
				...tagAlternateText,
				[lng]: text
			}
		})
	}
	return (
		<>
			<Container>
				<Label>{t('controls/image/tag/label')}</Label>
				<label htmlFor="image-tag">
					<Input
						id="image-tag"
						type="checkbox"
						value={true}
						checked={props.tag ? true : false}
						onChange={() => props.changesHandler({ tag: props.tag ? false : true })}
					/>
					<Description>{t('controls/image/tag/description')}</Description>
				</label>
			</Container>
			{ props.tag === true &&
			<Container>
				<Label>{t('controls/image/tag/alternativeLabel')}</Label>
				<label htmlFor="image-tag">
					<TextInput
						id="alternative-tag-text"
						type="input"
						value={tagAlternateText[lng]}
						onChange={e => handleAlternativeTagText(e.target.value)}
					/>
				</label>
			</Container>

			}
		</>
	)
}

Tag.propTypes = {
	t: PropTypes.func,
	tag: PropTypes.bool,
	tagAlternateText: PropTypes.string,
	changesHandler: PropTypes.func,
}

export default translate('translations')(Tag)
